
import { defineComponent } from 'vue'
import Navigation from './components/Navigation.vue'

export default defineComponent({
  components: {
    Navigation
  }
})
